import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import {
  FlowBox,
  StyledRoundedTabs,
  StyledRoundedTabList,
  StyledRoundedTab,
} from "blocks/atoms/uistyles";
import { useAtom } from "jotai";
import { useAppContext, checkIfNull } from "@app21/core";
import { useTasksContext } from "providers/TasksProvider";
import { centerpanelContextAtom } from "blocks/modules/Tasks/tasks-atoms";
import { Close, Reply, Edit } from "@mui/icons-material";
import { TaskBasicInputForm } from "blocks/modules/Tasks/foundations";

export const baseMenuOptions = [
  { value: "questions", label: "Your Response" },
  { value: "results", label: "Kanban" },
];

export default function TasksMenubar({ isMobile }) {
  const [centerpanelContext, setCenterpanelContext] = useAtom(
    centerpanelContextAtom
  );
  const {
    selectedDecision,
    actionContext,
    selectedTaskId,
    loadRoute,
    isDocket,
    tasksPermissions,
  } = useTasksContext();

  const handleChangeCenterpanelContext = (event, newValue) => {
    setCenterpanelContext(newValue);
  };

  if (!tasksPermissions?.canAddNew) return null;
  return (
    <FlowBox sx={{ height: "100%", flexShrink: 10 }}>
      <Box
        sx={{
          display: "flex",
          height: "100%",
          justifyContent: "space-between",
          pl: 5,
        }}
      >
        <TaskBasicInputForm />
        {/* <Box sx={{ flexGrow: 1 }}>
          <StyledRoundedTabs
            value={centerpanelContext}
            onChange={handleChangeCenterpanelContext}
            selectionFollowsFocus
            sx={{ maxWidth: 250 }}
          >
            <StyledRoundedTabList sx={{ p: 1 }}>
              {baseMenuOptions.map((option, index) => (
                <StyledRoundedTab
                  key={index}
                  value={option.value}
                  textColor="secondary"
                  sx={{ fontSize: "1.1 rem" }}
                >
                  {option.label}
                </StyledRoundedTab>
              ))}
            </StyledRoundedTabList>
          </StyledRoundedTabs>
        </Box> */}
        {/* <Box sx={{ maxWidth: 220, display: "flex", alignItems: "center" }}>
          {isDocket && (
            <Button
              size="small"
              variant="outlined"
              startIcon={<Reply />}
              sx={{ mr: 2 }}
              onClick={() =>
                loadRoute(isDocket ? "VIEW-RESOLUTION" : "VIEW-TASK", {
                  taskId: null,
                })
              }
            >
              View All
            </Button>
          )}
          {checkCanEdit(selectedDecision) &&
            selectedDecision.task.decisionStatus !== "CLOSED" &&
            checkIfNull(selectedDecision?.responses) &&
            (actionContext === "edit" ? (
              <Button
                size="small"
                variant="outlined"
                startIcon={<Close />}
                onClick={() =>
                  loadRoute(isDocket ? "VIEW-RESOLUTION" : "VIEW-TASK", {
                    taskId: selectedTaskId,
                  })
                }
              >
                Cancel
              </Button>
            ) : (
              <Button
                size="small"
                startIcon={<Edit />}
                variant="outlined"
                onClick={() =>
                  loadRoute(isDocket ? "EDIT-RESOLUTION" : "EDIT-TASK", {
                    taskId: selectedTaskId,
                  })
                }
              >
                Edit
              </Button>
            ))}
        </Box> */}
      </Box>
    </FlowBox>
  );
}
